import 'whatwg-fetch'
import 'custom-event-polyfill'
import 'core-js/stable/promise'
import 'core-js/stable/symbol'
import 'core-js/stable/string/starts-with'
import 'core-js/web/url'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { registerMicroApps, start } from 'qiankun'
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

import './style/main.scss'

Vue.config.productionTip = false

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

let HOST = ''
let HOSTNAME = ''
let PROTOCOL = ''
let PATHNAME = ''
let IS_DEV = false

// 如果页面正常打开，替换域名中 [www, app] 为 ''，用于适配指向子应用配置的域名
if (typeof window !== 'undefined') {
  HOSTNAME = window.location.hostname
  PROTOCOL = window.location.protocol
  PATHNAME = window.location.pathname
  HOST = window.location.host.replace('www', '').replace('app', '')

  // 本地开发模式
  if (HOSTNAME == 'localhost') {
    IS_DEV = true
    PROTOCOL = HOSTNAME == 'localhost' ? 'http:' : PROTOCOL
    HOST = HOSTNAME == 'localhost' ? '.eline56.io/' : HOST
  }
}

// 调试总开关 IS_DEV: true - 本地调试  false - 线上模式
// 子组件调试开关
const devMode = {
  user: IS_DEV ? 'dev' : 'line',
  track: IS_DEV ? 'line' : 'line',
  cpsqd: IS_DEV ? 'line' : 'line',
  cps: IS_DEV ? 'line' : 'line',
  vgm: IS_DEV ? 'line' : 'line',
  aci: IS_DEV ? 'line' : 'line',
  afr: IS_DEV ? 'line' : 'line',
  ams: IS_DEV ? 'line' : 'line',
  isf: IS_DEV ? 'line' : 'line',
  ics: IS_DEV ? 'dev' : 'line',
  em: IS_DEV ? 'line' : 'line'
}
console.log('ICS', devMode['ics'])
const conf = {
  user: {
    entry: devMode.user === 'line' ? PROTOCOL + '//user' + HOST : 'http://localhost:3020/'
  },
  home: {
    entry: PROTOCOL + '//home' + HOST
  },
  rpaControl: {
    entry: PROTOCOL + '//rpastore' + HOST
  },
  agent: {
    entry: PROTOCOL + '//agency' + HOST
  },
  grab: {
    entry: PROTOCOL + '//grab' + HOST
  },
  apistore: {
    entry: PROTOCOL + '//apistore' + HOST
  },
  track: {
    entry: devMode.track === 'line' ? PROTOCOL + '//track' + HOST : 'http://localhost:3000/'
  },
  cps: {
    entry: devMode.cps === 'line' ? PROTOCOL + '//cps' + HOST : 'http://localhost:3100/'
  },
  cpsqd: {
    entry: devMode.cpsqd === 'line' ? PROTOCOL + '//cpsqd' + HOST : 'http://localhost:3200/'
  },
  vgm: {
    entry: devMode.vgm === 'line' ? PROTOCOL + '//vgm' + HOST : 'http://localhost:3300/'
  },
  em: {
    entry: devMode.em === 'line' ? PROTOCOL + '//em' + HOST : 'http://localhost:3400/'
  },
  aci: {
    entry: devMode.aci === 'line' ? PROTOCOL + '//aci' + HOST : 'http://localhost:3401/'
  },
  afr: {
    entry: devMode.afr === 'line' ? PROTOCOL + '//afr' + HOST : 'http://localhost:3402/'
  },
  ams: {
    entry: devMode.ams === 'line' ? PROTOCOL + '//ams' + HOST : 'http://localhost:3403/'
  },
  isf: {
    entry: devMode.isf === 'line' ? PROTOCOL + '//isf' + HOST : 'http://localhost:3404/'
  },
  ics: {
    entry: devMode.ics === 'line' ? PROTOCOL + '//ics' + HOST : 'http://localhost:3405/'
  },
  freight: {
    entry: PROTOCOL + '//freight' + HOST
  },
  blenter: {
    entry: PROTOCOL + '//blenter' + HOST
  }
}

registerMicroApps([
  {
    name: 'wise-user-center',
    entry: conf.user.entry, // https://user.eline56.com/user/register
    container: '#appContainer',
    activeRule: '/user',
    props: { data: store }
  },
  // {
  //   name: 'wise-home', // 跳板子应用，当访问无效页面时，重定向到首页
  //   entry: conf.home.entry,
  //   container: '#appContainer',
  //   activeRule: '/home',
  //   props: { data: store }
  // },
  // {
  //   name: 'wise-rpa-control',
  //   entry: conf.rpaControl.entry,
  //   container: '#appContainer',
  //   activeRule: '/rpaControl',
  //   props: { data: store }
  // },
  {
    name: 'wise-agent',
    entry: conf.agent.entry,
    container: '#appContainer',
    activeRule: '/agent',
    props: { data: store }
  },
  // {
  //   name: 'wise-apistore',
  //   entry: conf.apistore.entry,
  //   container: '#appContainer',
  //   activeRule: '/apistore',
  //   props: { data: store }
  // },
  // {
  //   name: 'wise-blenter',
  //   entry: conf.blenter.entry,
  //   container: '#appContainer',
  //   activeRule: '/blenter',
  //   props: { data: store }
  // },
  {
    name: 'wise-cps',
    entry: conf.cps.entry,
    container: '#appContainer',
    activeRule: '/cps',
    props: { data: store }
  },
  {
    name: 'wise-cpsqd',
    entry: conf.cpsqd.entry,
    container: '#appContainer',
    activeRule: '/cpsqd',
    props: { data: store }
  },
  {
    name: 'wise-track',
    entry: conf.track.entry,
    container: '#appContainer',
    activeRule: '/track',
    props: { data: store }
  },

  {
    name: 'wise-vgm',
    entry: conf.vgm.entry,
    container: '#appContainer',
    activeRule: '/vgm',
    props: { data: store }
  },
  {
    name: 'wise-freight',
    entry: conf.freight.entry,
    container: '#appContainer',
    activeRule: '/freight',
    props: { data: store }
  },
  {
    name: 'wise-em',
    entry: conf.em.entry,
    container: '#appContainer',
    activeRule: '/em',
    props: { data: store }
  },
  {
    name: 'wise-aci',
    entry: conf.aci.entry,
    container: '#appContainer',
    activeRule: '/aci',
    props: { data: store }
  },
  {
    name: 'wise-afr',
    entry: conf.afr.entry,
    container: '#appContainer',
    activeRule: '/afr',
    props: { data: store }
  },
  {
    name: 'wise-ams',
    entry: conf.ams.entry,
    container: '#appContainer',
    activeRule: '/ams',
    props: { data: store }
  },
  {
    name: 'wise-isf',
    entry: conf.isf.entry,
    container: '#appContainer',
    activeRule: '/isf',
    props: { data: store }
  },
  {
    name: 'wise-ics',
    entry: conf.ics.entry,
    container: '#appContainer',
    activeRule: '/ics',
    props: { data: store }
  }
])

start()
